module.exports = function (number, locale = "en-US", currency = "AED") {
  if (!number) return "N/A";
  return number.toLocaleString(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
